var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 60C120 26.8595 93.1405 0 60 0C26.8595 0 0 26.8595 0 60C0 89.9532 21.9375 114.773 50.625 119.273V77.3437H35.3905V60H50.625V46.7812C50.625 31.746 59.5782 23.4375 73.289 23.4375C79.8515 23.4375 86.7188 24.6094 86.7188 24.6094V39.375H79.1485C71.6953 39.375 69.375 44.004 69.375 48.75V60H86.0155L83.3555 77.3437H69.375V119.273C98.0625 114.773 120 89.9532 120 60Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3556 77.3438L86.0156 60H69.3751V48.75C69.3751 44.004 71.6954 39.375 79.1486 39.375H86.7189V24.6094C86.7189 24.6094 79.8516 23.4375 73.2891 23.4375C59.5784 23.4375 50.6251 31.746 50.6251 46.7812V60H35.3906V77.3438H50.6251V119.273C53.6836 119.754 56.8126 120 60.0001 120C63.1876 120 66.3166 119.754 69.3751 119.273V77.3438H83.3556Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.1cf77989.svg";
export { ForwardRef as ReactComponent };